export default "__VITE_ASSET__yD9eRs5S__"